import { render, staticRenderFns } from "./XemNguoiDung.vue?vue&type=template&id=cc58bd20&"
import script from "./XemNguoiDung.vue?vue&type=script&lang=js&"
export * from "./XemNguoiDung.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports